import React, {useEffect, useState} from 'react';
import {ErrorMessage, Field, Formik} from 'formik';
import Question from "./Question";
import Graph from "./Graph";

import axios from "axios";

const Group = () => {
	function getData( grupo )
	{
		const data = {
			'1': {
				"search": [{
					"teste": 1,
					"grupo": 1,
					"frase_1": "Eu consigo manter o ritmo de uma m\u00fasica com um instrumento de percuss\u00e3o.",
					"frase_2": "Eu consigo me lembrar com detalhes importantes de lugares que visitei",
					"frase_3": "Eu percebo como as pessoas se sentem em seus relacionamentos",
					"frase_4": "Eu geralmente sei como me sinto em rela\u00e7\u00e3o \u00e0s coisas e a meus sentimentos",
					"frase_5": "Eu sempre quero saber como as coisas funcionam",
					"frase_6": "Minhas melhores ideias surgem em uma caminhada ou corrida",
					"frase_7": "Sou \u00f3timo em jogos de palavras cruzadas, anagramas e cruzadinhas"
				}]
			},
			'2': {
				"search":
					[{
						"teste": 1,
						"grupo": 2,
						"frase_1": "Aprendo novos esportes com facilidade",
						"frase_2": "Eu tenho um interesse grande em saber mais sobre eu mesmo",
						"frase_3": "L\u00ednguas e estudos sociais s\u00e3o mais f\u00e1ceis para mim do que ci\u00eancias exatas",
						"frase_4": "Matem\u00e1tica e ci\u00eancias s\u00e3o minhas mat\u00e9rias preferidas na escola",
						"frase_5": "Para mim geometria \u00e9 mais f\u00e1cil do que outras mat\u00e9rias da escola",
						"frase_6": "Quando sei alguma coisa, gosto de ensinar para outras pessoas",
						"frase_7": "Toco um instrumento musical"
					}]
			},
			'3': {
				"search": [{
					"teste": 1,
					"grupo": 3,
					"frase_1": "Eu organizo as coisas em minha mesa de trabalho com categoria e padr\u00e3o",
					"frase_2": "Eu prefiro passar a noite em casa do que em uma festa animada",
					"frase_3": "Eu tenho facilidade para resolver quebra cabe\u00e7a",
					"frase_4": "Gosto de passar meu tempo ao ar livre",
					"frase_5": "Minha cole\u00e7\u00e3o musical est\u00e1 entre as coisas mais preciosas para mim",
					"frase_6": "Prefiro praticar esportes em equipes",
					"frase_7": "Meus livros est\u00e3o entre as coisas mais preciosas para mim"
				}]
			},
			'4': {
				"search": [{
					"teste": 1,
					"grupo": 4,
					"frase_1": "Eu acho dif\u00edcil ficar sentado quieto por muito tempo",
					"frase_2": "Eu acredito que quase tudo tem uma explica\u00e7\u00e3o racional",
					"frase_3": "Eu consigo facilmente me orientar em locais pouco conhecidos",
					"frase_4": "Eu consigo perceber quando uma nota musical est\u00e1 desafinada",
					"frase_5": "Eu me sinto confort\u00e1vel em meio a uma multid\u00e3o",
					"frase_6": "Penso em ter meu pr\u00f3prio neg\u00f3cio e ser meu chefe",
					"frase_7": "Eu percebo erros gramaticais quando outras pessoas falam, nem sempre as corrijo"
				}]
			},
			'5': {
				"search": [{
					"teste": 1,
					"grupo": 5,
					"frase_1": "As pessoas costumam me ver como solit\u00e1rio",
					"frase_2": "As pessoas dizem que eu tenho uma voz agrad\u00e1vel",
					"frase_3": "Costumo desafiar meus amigos em jogos estrat\u00e9gicos",
					"frase_4": "Costumo gesticular bastante quando estou conversando com as pessoas",
					"frase_5": "Eu consigo visualizar imagens claramente quando fecho os olhos",
					"frase_6": "Eu me lembro de frases de efeito ou cita\u00e7\u00f5es e uso-as, como em conversas",
					"frase_7": "Tenho, pelo menos, tr\u00eas amigos \u00edntimos"
				}]
			},
		}

		return data[ grupo ];
	}

	function formatPhrases( data )
	{
		let formatted = [];
		for ( const key in data.search[ 0 ] ) {
			if ( key.indexOf( 'frase' ) > -1 ) {
				formatted.push( {
					                key: key.replace( 'frase_', '' ),
					                value: data.search[ 0 ][ key ]
				                } );
			}
		}
		return formatted;
	}

	async function validate( values )
	{
		const errors = detectDuplicated( values );

		for ( const index in values ) {
			if ( index === 'email' && !pessoa ) {
				const email = values.email.trim();
				if ( email === '' ) errors.email = <span className="error">Ops...você precisa informar seu email.</span>;
				else
					if ( await isEmailValid( email ) === false ) errors.email = <span className="error">Email inválido.</span>;
				continue;
			}
			if ( ['', 'Opinar'].includes( values[ index ] ) ) errors[ index ] = <span className="error">Ops...você precisar escolher um valor.</span>;
		}

		return errors;

		async function isEmailValid( email )
		{
			if ( /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( email ) ) {
				setEmail( email );

				return await axios.post( './Controller/router.php', {'class': 'Pessoas', 'method': 'create', 'email': email} )
				                  .then( response => JSON.parse( response.data ) )
				                  .then( data => {
					                  setPessoa( data );
				                  } );
			}

			return false;
		}

		function detectDuplicated( values )
		{
			const errors = {}
			let questions = {};
			for ( const index in values ) {
				if ( index === 'email' ) continue;
				questions[ index ] = values[ index ];
			}

			for ( const index in questions ) {
				for ( const i2 in questions ) {
					if ( index === i2 ) continue;
					if ( questions[ index ] === questions[ i2 ] ) {
						errors[ index ] = <span className="error-warning">Ops...você já utilizou esta nota em outra afirmação.</span>;
						errors[ i2 ] = errors[ index ];
					}
				}
			}

			return errors;
		}
	}

	function saveAnswers( answers )
	{
		axios.post( './Controller/router.php', {class: 'Respostas', method: 'create', data: answers} )
		     .then( response => JSON.parse( response.data ) );
	}

	function setInitialValues( email )
	{
		return {
			email: email ? email : '',
			question_1: '',
			question_2: '',
			question_3: '',
			question_4: '',
			question_5: '',
			question_6: '',
			question_7: '',
		}
	}

	function setAnswers( values )
	{
		return {
			pessoa,
			teste: 1,
			grupo,
			frase_1: values.question_1,
			frase_2: values.question_2,
			frase_3: values.question_3,
			frase_4: values.question_4,
			frase_5: values.question_5,
			frase_6: values.question_6,
			frase_7: values.question_7
		}
	}

	const [email, setEmail] = useState();
	const [pessoa, setPessoa] = useState();
	const [ended, setEnded] = useState( false );
	const [respostas, setRespostas] = useState( [] );
	const [grupo, setGrupo] = useState( 1 );
	const [questions, setQuestions] = useState( [] );

	useEffect( () => {
		if ( grupo > 5 ) return null;
		const data = getData( grupo );
		setQuestions( () => ( [...formatPhrases( data )] ) );
	}, [grupo] );

	if ( ended ) {
		document.querySelector( 'body' ).style = '';
		return <Graph respostas={respostas}/>
	}

	return <Formik
		initialValues={setInitialValues()}
		validate={validate}
		validateOnBlur={false}
		validateOnChange={false}
		onSubmit={( values, {resetForm, setValues} ) => {
			setGrupo( old => old + 1 );
			if ( grupo >= 5 ) setEnded( true );
			resetForm();
			setValues( setInitialValues( values.email ) );
			const answers = setAnswers( values );
			saveAnswers( answers );
			setRespostas( old => [...old, {...answers}] );
			document.querySelector( 'select' ).focus();
		}}
	>
		{props => {
			const dashedClassName = props.errors.email ? 'error-dashed' : '';
			return (
				<form onSubmit={props.handleSubmit}>
					<h3>Grupo {grupo}</h3>
					<div className={dashedClassName}>
						<Field name="email" type="email" autoFocus={true} placeholder="seu@email.com" disabled={email}/>
						<ErrorMessage name="email" component="div"/>
					</div>
					{questions.map( question => <Question key={question.key} data={question} {...props} /> )}
					<button type="submit">Enviar</button>
				</form>
			)
		}}
	</Formik>
};

export default Group;